import React from "react";
import { Card, Button, Typography } from "antd";
import { Link } from "react-router-dom";

const { Title } = Typography;

export const HomeFinanceCard = ({
  title,
  description,
  descriptionHref,
  buttonText,
  buttonHref,
}: {
  title: string;
  description: string;
  descriptionHref?: string;
  buttonText: string;
  buttonHref?: string;
}) => {
  return (
    <Card style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div>
          <Title level={3} style={{ margin: 0 }}>
            {title}
          </Title>
          {description && descriptionHref ? (
            <Link to={descriptionHref} style={{ display: "inline-block", marginTop: 8 }}>
              {description}
            </Link>
          ) : null}
        </div>

        {buttonText && buttonHref ? (
          <Button type="primary" size="large" href={buttonHref}>
            {buttonText}
          </Button>
        ) : null}
      </div>
    </Card>
  );
};

export default HomeFinanceCard;
